<template>
    <div id="badge_event">
        <h3 class='font-bold'>{{this.__( 'Badge Event', 'dokan' )}}</h3>
        <div class="seller-badge-event-dropdown">
            <div class="custom-select" @blur="open = false">
            <div class="selected" :class="{ open: open }" v-on:click="openDropdown()">
                <span v-if="getSelectedBadge().event.title">{{getSelectedBadge().event.title}}</span>
                <span v-else style="color: #646970">{{this.__( 'Select Event', 'dokan' )}}</span>
            </div>
            <div class="event-dropdown" :class="{ selectHide: !open }" v-if="! getSelectedBadge().id">
                <bars width="64" height="64" color="#007bff" v-if="! badges" />
                <div v-for="(events, group) in badges" class="dropdown__group">
                    <h4>{{ events[0].group.title }}</h4>
                    <span v-for="(event) in events">
                        <div class="single-item" v-on:click="event.created ? false: onItemClick(event);" :class="event.created ? 'already_created' : ''">
                            <div class="icon">
                                <img :src="event.badge_logo" width="26" height="28" alt="Icon">
                            </div>
                            <div class="info">
                                <h3>
                                    {{ event.title }}
                                    <i class="fas fa-check-circle" v-tooltip :title="getTooltipTitle(event)" :class="'published' === event.status ? 'badge-published' : 'badge-draft' " v-if="event.created"></i>
                                </h3>
                                <p>{{ event.description }}</p>
                            </div>
                        </div>
                    </span>
                    <!--end item-->
                </div>
                <!--end group-->
            </div>
        </div>
        </div>
    </div>
</template>

<script>

import Bars from "../../components/Bars.vue";
import mixin from "../../Mixin.js";

export default {
    name: 'BadgeEvents',

    mixins: [mixin],

    components: {
        Bars,
    },

    data () {
        return {
            open: false,
            isLoading: false,
            badges: null,
        }
    },

    inject: ['getSelectedBadge', 'setBadgeEvent', 'setBadgeLevels'],

    methods: {
        fetchBadgeEvents () {
            let self = this;
            self.isLoading = true;
            dokan.api.get('/seller-badge/events/')
            .done(async ( response ) => {
                self.badges = {};
                for( let event of response ) {
                    let index = event.group.key;
                    if ( ! self.badges[index] ) {
                        self.badges[index] = [];
                    }
                    self.badges[index].push( event );
                }
            }).always( () => {
                self.isLoading = false;
            } ).fail( ( jqXHR ) => {
                self.badges = {};
                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
            } );
        },

        openDropdown() {
            // check if badge id exists, if so show alert message
            if ( this.getSelectedBadge().id ) {
                const message = this.__( 'You can not change event type.', 'dokan' );
                this.showAlert( message, '', 'info' );
                return false;
            }
            this.open = ! this.open;
        },

        onItemClick( event ) {
            // check if event is already created
            if ( event.created ) {
                // show alert message
                this.showErrorAlert( this.__( 'Selected event is already created.', 'dokan' ) );
                return;
            }

            this.open = false;
            this.$root.$emit('resetDokanUploadImage', {src: event.badge_logo});
            this.setBadgeEvent(event);
            this.setBadgeLevels([]);
        },

        getTooltipTitle(event) {
            return event.created ? sprintf( this.__( 'Badge Status: %s', 'dokan' ), event.status  ) : ''
        }
    },

    created () {
        this.$watch(
            () => this.$route.params,
            () => {
                this.fetchBadgeEvents()
            },
            // fetch the data when the view is created and the data is
            // already being observed
            { immediate: true }
        )
    },
}
</script>

<style lang="less" scoped>
#badge_event {
    width: 48%;
    float: left;

    .selected {
        background: #FFFFFF;
        border: 1px solid #E2E2E2;
        border-radius: 2.5px;
        height: 40px !important;
        color: #000;
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
    }

    h3 {
        font-size: 1rem;
        margin: 0 0 0.625em;
    }
}
.seller-badge-event-dropdown {
    .custom-select {
        position: relative;
        width: 100%;
        text-align: left;
        outline: none;
        height: 47px;
        line-height: 40px;

        .selected {
            border-radius: 6px;
            border: 1px solid #666666;
            padding-left: 1em;
            cursor: pointer;
            user-select: none;

            &::after {
                content: "";
                position: absolute;
                border: solid #646970;
                border-width: 0 3px 3px 0;
                display: inline-block;
                padding: 3px;
                top: 15px;
                right: 1em;
                transform: rotate(45deg);
            }
        }
    }

    .event-dropdown {
        position: absolute;
        display: flex;
        flex-flow: row wrap;
        gap: 20px;
        width: 200%;
        min-height: 50px;
        border-radius: 3px;
        padding: 33px 25px 25px;
        background: #FFFFFF;
        border: 1px solid rgba(233, 238, 248, 0.9);
        box-shadow: 0px 14px 37px rgba(0, 0, 0, 0.1);
        margin: 22px -25px;
        z-index: 3;

        @media (max-width: 767px) {
            flex-direction: column;
            width: 100%;
            padding: 20px;
        }

        &::before {
            content: "";
            background: #FFFFFF;
            border: 1px solid #E9EEF8;
            width: 16px;
            height: 16px;
            position: absolute;
            top: -9px;
            left: 46.5%;
            transform: translateX(-50%) rotate(45deg);
            border-bottom-width: 0;
            border-right-width: 0;
            margin-left: 12px;
        }

        &::after {
            content: "";
            position: absolute;
            background: #F2F2F2;
            left: 48%;
            width: 1px;
            height: 92%;
            top: 29px;

            @media (max-width: 767px) {
                display: none;
            }
        }

        h4 {
            margin: 0 0 17px;
            font-weight: 700;
            font-size: 14px;
            line-height: 17px;
            color: #6D6D6D;
        }
    }

    .dropdown__group {
        flex-basis: 48%;
        max-width: 100%;

        .info {
            .fa-check-circle {
                font-size: 0.875rem;
                margin-left: 3px;

                &.badge-published {
                    color: #139F84;
                }

                &.badge-draft {
                    color: #c8c8c8;
                }
            }
        }
    }

    .single-item {
        display: flex;
        gap: 14px;
        transition: .3s linear 0s;
        position: relative;
        z-index: 1;
        padding: 10px;
        cursor: pointer;

        &:hover {
            background: #D3ECF7;
        }

        h3 {
            font-weight: 500;
            font-size: 13px;
            line-height: 16px;
            color: #000000;
            margin: 0 0 5px;
        }

        p {
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #575D64;
            margin: 0;
        }
    }
    .already_created{
        background-color: #f1f1f1;
        margin: 2px;
        &:hover {
            background-color: #f1f1f1;
            cursor: default !important;
        }
    }
    .selectHide {
        display: none;
    }
}
</style>
